import { http } from './config';

const PRODUCT_PATH = 'products';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;
    if (object.tecnologia !== undefined && object.tecnologia !== '') {
      params += `&tecnologia=${object.tecnologia}`;
    }
    if (object.fornecedor !== undefined && object.fornecedor !== '') {
      params += `&fornecedor=${object.fornecedor}`;
    }
    if (object.estrutura !== undefined && object.estrutura !== '') {
      params += `&estrutura=${object.estrutura}`;
    }
    return http.get(`${PRODUCT_PATH}?${params}`);
  },

  salvar: produto => http.post(PRODUCT_PATH, produto),

  atualizar: produto => http.post(`${PRODUCT_PATH}/${produto._id}`, produto),

  deletar: produto => http.delete(`${PRODUCT_PATH}/${produto._id}`),

  solicitar: produto =>
    http.post(`${PRODUCT_PATH}/${produto._id}/request`, {
      user: JSON.parse(localStorage.getItem('userData'))
    }),

  buscarKitProposta: psis => http.get(`${PRODUCT_PATH}/proposal-kit/${psis}`)
};
